import { get } from './http'

export function getSearch(keywords, page) {
  return get(`/api/news/search?keywords=${keywords}&page=${page}&pagesize=10`)
}
